<template>
  <div>
    <i18n path="text">
      <template v-slot:scratch>
        <a @click="setTemplate(vacancyTemplateTypes.SCRATCH)">{{ $t('empty') }}</a>
      </template>
      <template v-slot:express>
        <a @click="setTemplate(vacancyTemplateTypes.EXPRESS)">{{ $t('express') }}</a>
      </template>
    </i18n>
  </div>
</template>

<script>
import useGlobalEventEmitter from '@/compositions/useGlobalEventEmitter';
import { vacancyTemplateTypes } from '@/enums';

export default {
  name: 'VacancyPresetsListNotFound',
  setup() {
    const { emitEvent } = useGlobalEventEmitter('presets');

    function setTemplate(type) {
      emitEvent('setPreset', type);
    }

    return {
      emitEvent,
      vacancyTemplateTypes,
      setTemplate,
    };
  },
};
</script>

<style scoped>

</style>

<i18n lang="yml" locale="ru">
  empty: с нуля
  express: Экспресс-шаблон
  text: Не нашли подходящий шаблон? Создайте его с {scratch}, или используйте {express}.
</i18n>
<i18n lang="yml" locale="en">
  empty: scratch
  express: Express-template
  text: Can't find a template? Start from {scratch}, or use the {express}.
</i18n>
